import { error } from 'console';
import * as type from '../../ActionTypes';

const initialState = {
  reportDropdown: {},
  error: null,
  loading: false
};

export function reportDropdownReducer(state = initialState, action: any) {
  switch (action.type) {
    case type.GET_CLIENT_CODER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case type.GET_CLIENT_CODER_SUCCESS:
      return {
        ...state,
        reportDropdown: action.payload,
        loading: false
      };
    case type.GET_CLIENT_CODER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state;
  }
}

const initialTransactionReport = {
  transaction: {},
  loading: false,
  error: null
};

export function reportTransactionReducer(state = initialTransactionReport, action: any) {
  switch (action.type) {
    case type.GET_TRANSACTION_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        transaction: {},
        error: null
      };
    case type.GET_TRANSACTION_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        transaction: action.payload
      };
    case type.GET_TRANSACTION_REPORT_FAILURE:
      return {
        ...state,
        transaction: {},
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
}
